import React from "react";
import { connect } from "react-redux";
import ProcessState from "../../organisms/ProcessState/index";
import OrderProcessSimple from "../../organisms/OrderProcessSimple/index";
// import Getmoretoken from "../../organisms/Getmoretoken/index";
//import BountyPromo from '../../organisms/BountyPromo'
import { fetchUser } from "../../../actions";
import PersonalInformation from "../../molecules/PersonalInformation";
import Spinner from "../../atoms/Spinner";
import OrdersUser from "../../molecules/OrdersUser/container";
//import { Button } from "@material-ui/core";
import { Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
import PaymentInfo from "../../molecules/Paymentinfo";
import { Typography, Paper, Button, Container } from "@material-ui/core";

class Dashboard extends React.PureComponent {
  constructor(props) {
    super();
    this.showEditPIForm = this.showEditPIForm.bind(this);
    this.reloadPageUntilWhitelisted = this.reloadPageUntilWhitelisted.bind(
      this
    );
  }
  componentDidMount() {
    this.updateUserInfo();
  }

  componentDidUpdate() {
    this.reloadPageUntilAfterStep3();
  }

  updateUserInfo() {
    this.props.dispatch(fetchUser(this.reloadPageUntilWhitelisted));
  }

  reloadPageUntilAfterStep3() {
    const step = this.props.step;

    if (step === 3) {
      if (this.refreshInterval2Id) {
        //this avoids accumulating intervals crashing the browser
        clearInterval(this.refreshInterval2Id);
      }

      this.refreshInterval2Id = setInterval(() => {
        const stepInterval = this.props.step;

        if (!(stepInterval > 3)) {
          console.log("reloading page until verified2...");
          this.updateUserInfo();
        } else {
          console.log("verified2");
          clearInterval(this.refreshInterval2Id);
        }
      }, 2.5 * 1000);
    }
  }

  reloadPageUntilWhitelisted() {
    setTimeout(() => {
      console.log("reloading page until verified1...");
      this.updateUserInfo();
    }, 2.5 * 1000);
  }

  showEditPIForm() {
    this.setState({ showEditPIForm: true });
  }

  renderLastOrder() {
    return (
      <Paper style={{ padding: "1rem" }}>
        <Typography variant="h5" gutterBottom>
          Transaction details
        </Typography>
        <PaymentInfo order={this.props.User.Orders[0]} user={this.props.User} />
        <Paper square elevation={0} align="right">
          <Button
            color="primary"
            variant="outlined"
            to="/dashboard"
            component={Link}
          >
            GOTO DASHBOARD
          </Button>
        </Paper>
      </Paper>
    );
  }
  render() {
    const { error, loading, User /*, AffiliateStatus*/ } = this.props;

    if (error) {
      if (error.response && error.response.status === 401) {
        return <Redirect to="/error/authentication" />;
      } else {
        return <div>Error! {error.message}</div>;
      }
    }

    if (loading || this.props.step < 1) {
      return (
        <div align="center">
          <Spinner />
        </div>
      );
    }

    if (this.props.step === 4 && this.props.salesStep === 1) {
      if (
        this.props.location.pathname === "/dashboard/lastorder" &&
        this.props.User.Orders &&
        this.props.User.Orders.length > 0 &&
        this.props.User.Orders[0].Status === "created"
      ) {
        return this.renderLastOrder();
      } else {
        return (
          <Container>
            <div>
              {process.env.REACT_APP_STATUS !== "PAUSE" && (
                <OrderProcessSimple step={0} />
              )}
              {process.env.REACT_APP_STATUS === "PAUSE" && (
                <Paper
                  style={{
                    backgroundColor: "red",
                    textAlign: "center",
                    padding: "2em"
                  }}
                >
                  <Typography
                    variant="h5"
                    gutterBottom
                    style={{ color: "white" }}
                  >
                    The contract is in paused state. Ether sent will be
                    rejected.
                  </Typography>
                </Paper>
              )}
              <OrdersUser />
              {/* <BountyPromo /> */}
              {/* <Getmoretoken
              AFFID={User.AffiliateLinks}
              AffiliateStatus={AffiliateStatus}
            /> */}

              <PersonalInformation {...User} />
            </div>
          </Container>
        );
      }
    } else {
      return (
        <Container>
          <div>
            <ProcessState
              step={this.props.step}
              userstatus={this.props.UserStatus}
            />

            {/* <BountyPromo /> */}
            {/* <Getmoretoken
            AFFID={User.AffiliateLinks}
            AffiliateStatus={AffiliateStatus}
          /> */}
            <PersonalInformation {...User} />
            {/* <Button
            variant="outlined"
            component={Link}
            to="/dashboard/user/edit"
            style={{ marginTop: "1rem" }}
          >
            Edit Personal Information
          </Button> */}
          </div>
        </Container>
      );
    }
  }
}

const mapStateToProps = state => ({
  User: state.User,
  UserStatus: state.Status,
  AffiliateStatus: state.AffiliateStatus,
  loading: state.loading,
  error: state.errorLoading,
  step: state.processState,
  salesStep: state.salesStep
});

export default connect(mapStateToProps)(Dashboard);
